import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Login from "../pages/Login";
import Dashboardmain from "../DashBoardmain";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPass from "../pages/Reset_Pass";
import DashBoard from "../pages/DashBoard";
import AMSPage from "../pages/AMSPage";
import AssetList from "../pages/assetlist";
import AssignAsset from "../pages/AssignAsset";
import FreeAsset from "../pages/FreeAsset";
import MaintenanceAsset from "../pages/Maintenance";
import ModuleProtectedRoute from "./ModuleProtectedRoute";

// Approvals
import AssignApproval from "../pages/Approval/Assigned";
import MaintenanceApproval from "../pages/Approval/UnderMaintenance";
import FreePoolApproval from "../pages/Approval/FreePool";
import POApproval from "../pages/Approval/PurchaseOrder";
import InvoiceApproval from "../pages/Approval/Invoice";
import PaymentApproval from "../pages/Approval/Payment";
import BulkApproval from "../pages/Approval/bulk_upload";

// New Asset
import Pomain from "../pages/New_Asset/POMain";
import CreatePO from "../pages/New_Asset/Create_PO";
import EditPO from "../pages/New_Asset/Edit_PO";
import UploadInvoice from "../pages/New_Asset/Upload_Invoice";
import Edit_Invoice from "../pages/New_Asset/Edit_Invoice";
import UploadReciept from "../pages/New_Asset/Upload_Reciept";
import AssetDepreciation from "../pages/New_Asset/AssetDepreciation";

//bulk upload
import BulkUpload from "../pages/BulkUpload";
import RoleBase from "../pages/RoleBase/RoleBasedaccessmain";

// HO USER
import CreditBulkUpload from "../pages/HO_USER/HObulkupload";
import RORecornUpload from "../pages/RecornUpload/Recorncustomer";
import ROReport from "../pages/RO_USER/ROReport";
import ROpage from "../pages/RO_USER/ROpage";
import Roassign from "../pages/RO_USER/Roassign";
import BOReport from "../pages/BO_USER/BOReport";
import BOpage from "../pages/BO_USER/BOpage";
import BOassign from "../pages/BO_USER/BOassign";
import CustomerMain from "../pages/BO_USER/CustomerMain";
import Customermaker from "../pages/BO_USER/CustomerEdit";

//Recorn
import Recorncustomer from "../pages/RecornUpload/Recorncustomer";

// CIC
import HOReport from "../pages/HO_USER/HOReport";
import ManagerReport from "../pages/ManagerReport/ManagerReport";
import SessionChecker from "./SessionChecker";

// Call Track Module
import CallBulkUpload from "../pages/CallTrackModule/callBulkUpload";
import CallReport from "../pages/CallTrackModule/callReport";
import CallDashboard from "../pages/CallTrackModule/CallDashboard";
import SheetList from "../pages/CallTrackModule/sheets/SheetList";
// import CreateQuestions from "../pages/CallTrackModule/Questions/CreateQuestions";
import QuestionManagement from "../pages/CallTrackModule/QuestionManagement/QuestionManagement";

import Telecaller from "../pages/CallTrackModule/Telecall/telecaller";
import Branchcaller from "../pages/CallTrackModule/branchcall/branchcaller";
import PendingAcceptance from "../pages/PendingAcceptance";
import Acceptance from "../pages/Approval/Acceptance";
import Search from "../pages/CallTrackModule/searchHistory/search";
import AssetTransfer from "../pages/AssetTransfer";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  return isLoggedIn ? children : <Navigate to="/" />;
};
const MODULES = {
  HOME: "IT-HOME",
  APPROVAL: "IT-APPROVAL",
  NEW_ASSETS: "IT-NEW ASSETS",
  BULK_UPLOAD: "IT-Bulk Upload",
  ASSET_DEPRECIATION: "IT-Asset Depreciation",
  USER_ROLES: "IT-User Roles",
  MANAGER_REPORT: "IT-REPORT",

  HO_REPORT: "HO_Report",
  HO_ASSIGN: "HO_Assign",
  HO_RECORN: "HO_Recorn",

  RO_REPORT: "RO_Report",
  RO_ACCEPT: "RO_Accept",
  RO_ASSIGN: "RO_Assign",

  BO_REPORT: "BO_Report",
  BO_ACCEPT: "BO_Accept",
  BO_ASSIGN: "BO_Assign",

  CALL_REPORT: "CALL_Report",
  CALL_ADMIN: "CALL_ADMIN",
  CALL_Telecaller: "CALL_Telecaller",
  CALL_Branch: "CALL_Branch",
};

const AppRoutes = () => {
  return (
    <Router>
      <SessionChecker />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/ResetPassword" element={<ResetPass />} />

        {/* Protected Routes */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Routes>
                {/* Dashboard and Asset Management */}
                {/* <Route path="/DashBoardmain" element={<Dashboardmain />} /> */}
                {/* <Route path="/components/dashboardreports" element={<Dashboardreports />}/> */}

                <Route path="/DashBoard" element={<DashBoard />} />
                <Route
                  path="/AMSDashBoard"
                  // element={<AMSPage />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.HOME}>
                      <AMSPage />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/manager-report"
                  // element={<ManagerReport />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.MANAGER_REPORT}>
                      <ManagerReport />
                    </ModuleProtectedRoute>
                  }
                />
                <Route path="/:category/:type" element={<AssetList />} />
                <Route
                  path="/pending-accept/:assetType"
                  element={<PendingAcceptance />}
                />
                <Route
                  path="/assign-asset/:encodedAssetId"
                  element={<AssignAsset />}
                />
                <Route
                  path="/free-asset/:encodedAssetId"
                  element={<FreeAsset />}
                />
                <Route
                  path="/undermaintenance-asset/:encodedAssetId"
                  element={<MaintenanceAsset />}
                />
                <Route
                  path="/transfer-asset/:assetId"
                  element={<AssetTransfer />}
                />

                {/* Approval Routes */}
                <Route
                  path="/approval/acceptance"
                  // element={<AssignApproval />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.APPROVAL}>
                      <Acceptance />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/approval/assigned"
                  // element={<AssignApproval />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.APPROVAL}>
                      <AssignApproval />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/approval/under-maintenance"
                  // element={<MaintenanceApproval />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.APPROVAL}>
                      <MaintenanceApproval />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/approval/free-pool"
                  // element={<FreePoolApproval />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.APPROVAL}>
                      <FreePoolApproval />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/approval/po"
                  // element={<POApproval />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.APPROVAL}>
                      <POApproval />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/approval/invoice"
                  // element={<InvoiceApproval />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.APPROVAL}>
                      <InvoiceApproval />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/approval/payment"
                  // element={<PaymentApproval />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.APPROVAL}>
                      <PaymentApproval />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/approval/bulk"
                  // element={<BulkApproval />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.APPROVAL}>
                      <BulkApproval />
                    </ModuleProtectedRoute>
                  }
                />

                {/* New Asset Routes */}
                <Route
                  path="/new-assets/purchesorder"
                  //  element={<Pomain />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.NEW_ASSETS}>
                      <Pomain />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/new-assets/create-po"
                  // element={<CreatePO />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.NEW_ASSETS}>
                      <CreatePO />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/new-assets/edit-po/:po_number"
                  // element={<EditPO />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.NEW_ASSETS}>
                      <EditPO />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/new-assets/upload-invoice/:po_number"
                  // element={<UploadInvoice />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.NEW_ASSETS}>
                      <UploadInvoice />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/new-assets/edit-invoice/:po_number"
                  // element={<Edit_Invoice />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.NEW_ASSETS}>
                      <Edit_Invoice />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/new-assets/upload-reciept"
                  // element={<UploadReciept />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.NEW_ASSETS}>
                      <UploadReciept />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/new-assets/assetdepreciation"
                  // element={<AssetDepreciation />}
                  element={
                    <ModuleProtectedRoute
                      moduleName={MODULES.ASSET_DEPRECIATION}
                    >
                      <AssetDepreciation />
                    </ModuleProtectedRoute>
                  }
                />

                {/* BulkUpload and RoleBase Routes */}
                <Route
                  path="/BulkUpload"
                  // element={<BulkUpload />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.BULK_UPLOAD}>
                      <BulkUpload />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/user_roles"
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.USER_ROLES}>
                      <RoleBase />
                    </ModuleProtectedRoute>
                  }
                />

                {/* HO User Routes */}
                <Route path="/ho-user/horeport" element={<HOReport />} />
                <Route
                  path="/ho-user/credit_bulk-upload"
                  element={<CreditBulkUpload />}
                />
                <Route
                  path="/ro-user/recorn-upload"
                  element={<RORecornUpload />}
                />

                {/* <Route path="/ho-user/rounassign" element={<RO />} /> */}
                <Route path="/ro-user/roreport" element={<ROReport />} />
                <Route path="/ho-user/ropage" element={<ROpage />} />
                <Route path="/ho-user/roassign" element={<Roassign />} />

                {/* <Route path="/ho-user/bo" element={<BO />} /> */}
                <Route path="/bo-user/boreport" element={<BOReport />} />
                <Route path="/bo-user/bopage" element={<BOpage />} />
                <Route path="/bo-user/boassign" element={<BOassign />} />

                <Route path="/bo-user/assign-bo" element={<CustomerMain />} />

                <Route path="/recorn" element={<Recorncustomer />} />

                {/* Call Track Module */}
                <Route path="/track/Dashboard" element={<CallDashboard />} />

                <Route
                  path="/track/sheetList"
                  // element={<SheetList />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.CALL_ADMIN}>
                      <SheetList />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/track/questionmanage"
                  // element={<QuestionManagement />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.CALL_ADMIN}>
                      <QuestionManagement />
                    </ModuleProtectedRoute>
                  }
                />

                <Route
                  path="/track/Call-BulkUpload"
                  // element={<CallBulkUpload />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.CALL_ADMIN}>
                      <CallBulkUpload />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/track/Call-Report"
                  // element={<CallReport />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.CALL_ADMIN}>
                      <CallReport />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/track/Call-search"
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.CALL_ADMIN}>
                      <Search />
                    </ModuleProtectedRoute>
                  }
                />

                <Route
                  path="/tele/Call"
                  // element={<Telecaller />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.CALL_Telecaller}>
                      <Telecaller />
                    </ModuleProtectedRoute>
                  }
                />
                <Route
                  path="/brch/Call"
                  // element={<Branchcaller />}
                  element={
                    <ModuleProtectedRoute moduleName={MODULES.CALL_Branch}>
                      <Branchcaller />
                    </ModuleProtectedRoute>
                  }
                />

                {/* <Route path="/bo-user/customeredit/:docket_id" element={<Customermaker />} /> */}
              </Routes>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
